import { OrgOption } from './types'
import { OrganizationItem } from './OrganizationItem'
import { DividerLine } from './DividerLine'

interface OrganizationGroupProps {
  title: string
  items: OrgOption[]
  selectedOptions: OrgOption[]
  onOptionClick?: (item: OrgOption) => void
  onOptionCheck: (item: OrgOption) => void
  withDivider?: boolean
}

export function OrganizationGroup({
  title,
  items,
  selectedOptions,
  onOptionClick,
  onOptionCheck,
  withDivider = false
}: OrganizationGroupProps) {
  return (
    <div className="relative mt-4">
      {withDivider && <DividerLine position="above" />}
      <div className="helix-border helix-border-radius--sm helix-border--gray-300 helix-p-2">
        <div className="helix-mb-2 helix-subheading text-center uppercase text-gray-500">
          {title} ({items.length})
        </div>
        <div
          className={`grid gap-3 ${
            items.length === 1
              ? 'grid-cols-1'
              : items.length === 2
              ? 'grid-cols-2'
              : 'grid-cols-3'
          }`}>
          {items.map((item) => (
            <OrganizationItem
              isGroup
              key={item.value.id}
              item={item}
              isChecked={selectedOptions.some(
                (s) => s.value.id === item.value.id
              )}
              onClick={onOptionClick ? () => onOptionClick(item) : undefined}
              onCheckChange={() => onOptionCheck(item)}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
